import { RadioGroup as ChakraRadioGroup, RadioGroupRootProps } from '@chakra-ui/react'
import { Box, Flex, Text } from 'components'
import { RadioLineParams } from 'types'
import { TextProps } from '.'

export interface Props
  extends Omit<
      RadioGroupRootProps,
      'children' | 'onChange' | 'onValueChange' | 'options' | 'value'
    >,
    Omit<Partial<RadioLineParams>, 'minValueText' | 'maxValueText'> {
  colorScheme?: string
  maxValueText?: string
  minValueText?: string
  onChange?: (value: number | null) => void
  value?: number | null
  textProps?: TextProps
}

export default function RadioLine({
  maxValueText = '5 (Extremely)',
  minValueText = '1 (Not at all)',
  onChange,
  textProps,
  minValue = 1,
  maxValue = 5,
  value,
  step = 1,
  ...rest
}: Props) {
  const options = Array.from({ length: (maxValue - minValue) / step + 1 }, (_, i) =>
    (minValue + i * step).toString()
  )

  return (
    <ChakraRadioGroup.Root
      colorPalette="primary"
      asChild
      size="md"
      onValueChange={onChange ? e => onChange(e.value ? Number(e.value) : null) : undefined}
      value={value?.toString()}
      {...rest}
    >
      <Flex direction="column" gap={2} alignItems="stretch">
        <Flex align="center" justify="space-between">
          <Text {...textProps}>{minValueText}</Text>
          <Text {...textProps}>{maxValueText}</Text>
        </Flex>
        <Flex justifyContent="space-between">
          {options.map((value, index) => (
            <ChakraRadioGroup.Item
              gap={0}
              flex={index < options.length - 1 ? 1 : 0}
              key={value}
              cursor="pointer"
              value={value}
            >
              <ChakraRadioGroup.ItemHiddenInput />
              <ChakraRadioGroup.ItemIndicator />
              {index < options.length - 1 && (
                <Box
                  flex={1}
                  height="1px"
                  borderBottom="1px dashed rgba(0, 0, 0, 0.3)"
                  alignSelf="center"
                />
              )}
            </ChakraRadioGroup.Item>
          ))}
        </Flex>
      </Flex>
    </ChakraRadioGroup.Root>
  )
}
